Namespace 'Common'

class Common.WidgetDimensions
  @SUBTYPE = 'subtype'
  @GROUP = 'group'
  @FILTERED_GROUP = 'filtered_group'
  @TAXONOMIC_ATTRIBUTE = 'custom_attribute'
  @FILTERED_TAXONOMIC_ATTRIBUTE = 'filtered_custom_attribute'
  @TICKET_STATUS = 'ticket_status'
  @ASSIGNED_OPERATOR = 'assigned_operator'
  @ASSIGNED_GROUP = 'assigned_group'
  @HIERARCHICAL_ATTRIBUTE = 'hierarchical_attribute'
  @CLOSED_CONVERSATIONS_PER_AGENT = 'closed_conversations_per_agent'
